exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select:hover {\n\tcursor:pointer;\n\tbackground-color:#B7B3B3;\n}\n", ""]);

// exports
